import gql from 'graphql-tag';

export const getCommFailSeverities = gql`
  query getCommFailSeverities {
    getCommFailSeverities {
      id
      name
    }
  }
`;
